var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnualDiscountArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 2.87168L11.2757 3.28081L10.9883 2.87168ZM4.27592 15.67C4.05847 15.8402 3.74421 15.8019 3.57401 15.5845L0.800312 12.0409C0.630103 11.8235 0.668401 11.5092 0.885849 11.339C1.1033 11.1688 1.41756 11.2071 1.58776 11.4246L4.05327 14.5744L7.20308 12.1089C7.42052 11.9387 7.73478 11.9769 7.90499 12.1944C8.0752 12.4118 8.0369 12.7261 7.81945 12.8963L4.27592 15.67ZM22.1155 1.97499C20.472 1.08377 15.914 0.0223184 11.2757 3.28081L10.7009 2.46255C15.702 -1.05082 20.6751 0.0563433 22.5922 1.09591L22.1155 1.97499ZM11.2757 3.28081C8.95841 4.90875 7.33438 7.24881 6.24667 9.53685C5.15879 11.8252 4.62357 14.0278 4.46406 15.3368L3.4714 15.2158C3.64385 13.8007 4.20905 11.4939 5.34353 9.10751C6.47817 6.72075 8.19843 4.22055 10.7009 2.46255L11.2757 3.28081Z",
    fill: "#465C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualDiscountArrow);
export default __webpack_public_path__ + "static/media/annual_discount_arrow.4857403aca6c773e7a35f53c1f4fe367.svg";
export { ForwardRef as ReactComponent };